import React from 'react';

import amplitude from 'amplitude-js';
import ResidenceAddressUpdatePopup from 'apps/auth/components/common/popups/ResidenceAddressUpdatePopup';
import ChooseWhoToSendPopup from 'apps/auth/components/history/send/popup/ChooseWhoToSendPopup';
import NotFinishedTransactionsPopup from 'apps/auth/components/history/send/popup/NotFinishedTransactionsPopup';
import KYCModal from 'apps/auth/components/kyc/KYCModal';
import KycPopup from 'apps/auth/components/notificationPopup/KycPopup';
import MyIdLuluKycPopup from 'apps/auth/components/notificationPopup/MyIdLuluKycPopup';
import ProfileUpdatePopup from 'apps/auth/components/notificationPopup/ProfileUpdatePopup';
import TermsUpdatePopup from 'apps/auth/components/notificationPopup/TermsUpdatePopup';
import VisaUkrainePopup from 'apps/auth/components/notificationPopup/VisaUkrainePopup';
import UsaHighRiskCountryOptInModal from 'apps/auth/components/send/optIn/UsaHighRiskCountryOptInModal';
import TextPopup from 'apps/auth/components/sharedComponents/popups/TextPopup';
import { RESTRICTED_COUNTRY_BOTTOM_SHEET_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PAYOUT_COUNTRY } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { NEED_TO_SIGN_LULU_TERMS, NEED_TO_SIGN_MY_ID_TERMS } from 'apps/auth/constants/ExtraNames';
import {
    AUTH_PROFILE_AML_LEVEL,
    AUTH_REQUEST_MAIN_LINK,
    AUTH_REQUEST_PAY_LINK,
    AUTH_SEND,
    AUTH_SEND_INCOMPLETE_PAYMENT_CONTINUE_ACTION,
    AUTH_SEND_LINK,
    AUTH_SEND_MAIN_LINK,
    AUTH_SEND_REPEAT,
    AUTH_TERMS_LULU_CONFIRM,
    AUTH_TERMS_MY_ID_CONFIRM,
} from 'apps/auth/constants/UrlConstants';
import { toLowerCase } from 'apps/auth/helpers/utils';

export class GTRestrictionService {
    #extra;
    #messages;
    #cheque;
    //actions
    #toggleModal;
    #toggleSpinner;
    //refs
    #popupRef;
    #popupFullwidthRef;
    #modalRef;
    #eventInfo;

    constructor(messages, popupRef, eventInfo, popupFullwidthRef, modalRef) {
        this.#messages = messages;
        this.#popupRef = popupRef;
        this.#eventInfo = eventInfo;
        this.#popupFullwidthRef = popupFullwidthRef;
        this.#modalRef = modalRef;
    }

    setExtra(extra) {
        this.#extra = extra;
    }

    setCheque(cheque) {
        this.#cheque = cheque;
    }

    setActions(toggleModal, toggleSpinner) {
        this.#toggleModal = toggleModal;
        this.#toggleSpinner = toggleSpinner;
    }

    checkChequeRestriction(e, isRequest = false, isIncompleteTransfer = false) {
        const cheque = this.#cheque.cheque;
        let redirectUrl, changeDeliveryMethod;

        if (this.#extra?.residenceAddressMustBeUpdated) {
            e?.preventDefault();
            this.#popupRef.current?.open(<ResidenceAddressUpdatePopup popupRef={this.#popupRef} />);
            return;
        }

        if (isRequest) {
            redirectUrl = `${AUTH_REQUEST_PAY_LINK}/${cheque?.id}`;
            changeDeliveryMethod = AUTH_REQUEST_MAIN_LINK;
        } else if (isIncompleteTransfer) {
            redirectUrl = AUTH_SEND_INCOMPLETE_PAYMENT_CONTINUE_ACTION;
            changeDeliveryMethod = AUTH_SEND_INCOMPLETE_PAYMENT_CONTINUE_ACTION;
        } else {
            redirectUrl = `${AUTH_SEND_REPEAT}?repeatId=${cheque?.paymentId}`;
            changeDeliveryMethod = `${AUTH_SEND_LINK}/${cheque?.toCountry.code}/${toLowerCase(cheque?.amountToCurrency)}`;
        }
        if (!cheque?.deliveryMethodAvailable && !isRequest) {
            e.preventDefault();
            this.#popupRef.current?.open(
                <TextPopup
                    popupRef={this.#popupRef}
                    text={this.#messages?.transferMethodNotAvailable}
                    buttonText={this.#messages?.gotIt}
                    eventInfo={this.#eventInfo}
                />,
            );
        } else if (cheque?.transferTemporarilyUnavailableSourceTo && !isRequest) {
            e.preventDefault();
            this.#popupRef.current?.open(
                <TextPopup
                    popupRef={this.#popupRef}
                    text={this.#messages?.transferTemporarilyNotAvailableSource}
                    buttonText={this.#messages?.changeDeliveryOption}
                    onClick={() => {
                        this.#popupRef.current?.close();
                        window.location.href = `${AUTH_SEND_LINK}/${cheque?.toCountry.code}/delivery`;
                    }}
                />,
            );
        } else if (this.#cheque?.showModalProfileUpdateBlock) {
            e.preventDefault();
            this.#popupRef.current?.open(<ProfileUpdatePopup popupRef={this.#popupRef} redirectUrl={redirectUrl} />);
        } else if (this.#cheque?.showModalTermsUpdateBlock) {
            e.preventDefault();
            this.#popupRef.current?.open(<TermsUpdatePopup popupRef={this.#popupRef} redirectUrl={redirectUrl} />);
        } else if (this.#cheque?.showModalKycInvalidBlock) {
            e.preventDefault();
            this.#popupRef.current?.open(<KycPopup popupRef={this.#popupRef} />);
        } else if (this.#cheque?.showModalPaymentRestriction || this.#extra?.showMigrationNotificationToBetaPs3) {
            e?.preventDefault();
            const shouldShowMigrationOnlyModal = this.#extra?.showMigrationNotificationToBetaPs3;
            if (shouldShowMigrationOnlyModal && this.#popupFullwidthRef?.current && this.#modalRef) {
                this.#popupFullwidthRef.current.open(
                    <UsaHighRiskCountryOptInModal
                        modalRef={this.#modalRef}
                        popupFullwidthRef={this.#popupFullwidthRef}
                        country={cheque?.toCountry}
                        title={this.#messages?.migrationOnlyTitle}
                        subtitle={this.#messages?.migrationOnlySubTitle}
                    />,
                );
            } else {
                amplitude.getInstance().logEvent(RESTRICTED_COUNTRY_BOTTOM_SHEET_SHOWN, {
                    [PAYOUT_COUNTRY]: cheque?.toCountry?.nameEn,
                });
                this.#popupRef.current?.open(
                    <TextPopup popupRef={this.#popupRef} text={this.#messages?.notificationText} buttonText={this.#messages?.gotIt} />,
                );
            }
        } else if (cheque?.showVisaUkraineNotificationInfo) {
            e.preventDefault();
            this.#popupRef.current?.open(
                <VisaUkrainePopup
                    popupRef={this.#popupRef}
                    text={this.#messages?.visaUkraineNotificationText}
                    continueButtonUrl={redirectUrl}
                    continueButtonText={this.#messages?.continueButton}
                    changeButtonText={this.#messages?.changeDeliveryMethod}
                    changeButtonUrl={changeDeliveryMethod}
                />,
            );
        } else if (this.#extra?.needToSignMyIdTerms) {
            e.preventDefault();
            this.#popupRef.current?.open(
                <MyIdLuluKycPopup
                    popupRef={this.#popupRef}
                    redirectUrl={redirectUrl}
                    confirmUrl={AUTH_TERMS_MY_ID_CONFIRM}
                    content={this.#messages.termsDislaimerUzText}
                />,
            );
        } else if (this.#extra?.needToSignLuluTerms) {
            e.preventDefault();
            this.#popupRef.current?.open(
                <MyIdLuluKycPopup
                    popupRef={this.#popupRef}
                    redirectUrl={redirectUrl}
                    confirmUrl={AUTH_TERMS_LULU_CONFIRM}
                    content={this.#messages.termsDislaimerAeText}
                />,
            );
        } else {
            this.#toggleSpinner(true);
        }
    }

    checkRestrictions(e) {
        let popup = null;
        let modal = null;

        if (this.#extra?.residenceAddressMustBeUpdated) {
            popup = <ResidenceAddressUpdatePopup popupRef={this.#popupRef} />;
        } else if (this.#extra?.show_modal_unconfirmed_transaction) {
            popup = <NotFinishedTransactionsPopup popupRef={this.#popupRef} />;
        } else if (this.#extra?.show_modal_profile_update_block) {
            popup = <ProfileUpdatePopup popupRef={this.#popupRef} />;
        } else if (this.#extra?.show_modal_kyc_invalid_block) {
            modal = (
                <KYCModal
                    profilePurpleBlock={this.#messages.kycModalTitleFirst}
                    increase_block={this.#messages.kycModalTitleSecond}
                    increase_sub_block={this.#messages.kycModalGreyText}
                    notificationButton={this.#messages.kycModalCancel}
                    onClickNotNow={(event) => {
                        event.preventDefault();
                        this.#toggleModal(false);
                    }}
                    nextButton={this.#messages.continue}
                    nextButtonLink={`${AUTH_PROFILE_AML_LEVEL}/${this.#extra?.currentLimitLevel + 1}/docs`}
                />
            );
        } else if (this.#extra?.show_modal_terms_update_block) {
            popup = (
                <TermsUpdatePopup
                    popupRef={this.#popupRef}
                    redirectUrl={this.#extra.sendFlowV3 ? `${AUTH_SEND_MAIN_LINK}?showRecipientTypePopup=true` : AUTH_SEND}
                />
            );
        } else if (this.#extra?.needToSignMyIdTerms) {
            popup = (
                <MyIdLuluKycPopup
                    popupRef={this.#popupRef}
                    redirectUrl={this.#extra.sendFlowV3 ? `${AUTH_SEND_MAIN_LINK}?showRecipientTypePopup=true` : AUTH_SEND}
                    confirmUrl={AUTH_TERMS_MY_ID_CONFIRM}
                    content={this.#messages.termsDislaimerUzText}
                    extraName={NEED_TO_SIGN_MY_ID_TERMS}
                />
            );
        } else if (this.#extra?.needToSignLuluTerms) {
            popup = (
                <MyIdLuluKycPopup
                    popupRef={this.#popupRef}
                    redirectUrl={this.#extra.sendFlowV3 ? `${AUTH_SEND_MAIN_LINK}?showRecipientTypePopup=true` : AUTH_SEND}
                    confirmUrl={AUTH_TERMS_LULU_CONFIRM}
                    content={this.#messages.termsDislaimerAeText}
                    extraName={NEED_TO_SIGN_LULU_TERMS}
                />
            );
        } else if (this.#extra?.chooseWhoToSendPopup) {
            popup = <ChooseWhoToSendPopup uri={AUTH_SEND_LINK} popupRef={this.#popupRef} />;
        }

        if (popup) {
            e.preventDefault();
            e.stopPropagation();
            this.#popupRef.current?.open(popup);
        } else if (modal) {
            e.preventDefault();
            e.stopPropagation();
            this.#toggleModal(true, modal, false);
        } else {
            this.#toggleSpinner(true);
        }
    }
}
